import script from "./ProposalsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ProposalsTable.vue?vue&type=script&setup=true&lang=js"

import "./ProposalsTable.vue?vue&type=style&index=0&id=663f9afe&lang=css"

const __exports__ = script;

export default __exports__